module.exports = __webpack_public_path__ + "img/app_download_hint.472ddcc.jpg";